<template>
  <main>
    <div class="container">
      <div class="position-relative d-flex align-items-center mb-3">
        <div class="w-100">
          <h1 class="orbitron-font text-title mx-auto mb-0">Pruebas</h1>
        </div>
      </div>
      <!-- #################### VISIBILIDAD #################### -->
      <div class="row justify-content-center gap-3 m-1">
        <div class="col-md-12">
          <button type="button" class="btn btn-plain hover-neon" :class="isVisibleBotones ? 'red' : 'yellow'" @click="isVisibleBotones = !isVisibleBotones">
            {{ isVisibleBotones ? 'Ocultar Botones' : 'Mostrar Botones' }}
          </button>
          <button type="button" class="btn btn-plain hover-neon" :class="isVisibleTextos ? 'red' : 'yellow'" @click="isVisibleTextos = !isVisibleTextos">
            {{ isVisibleTextos ? 'Ocultar Textos' : 'Mostrar Textos' }}
          </button>
          <button type="button" class="btn btn-plain hover-neon" :class="isVisibleModales ? 'red' : 'yellow'" @click="isVisibleModales = !isVisibleModales">
            {{ isVisibleModales ? 'Ocultar Modales' : 'Mostrar Modales' }}
          </button>
        </div>
        <div class="col-md-12">
          <button type="button" class="btn btn-plain hover-neon" :class="isVisibleCarousel ? 'red' : 'main'" @click="isVisibleCarousel = !isVisibleCarousel">
            {{ isVisibleCarousel ? 'Ocultar Carousel' : 'Mostrar Carousel' }}
          </button>
          <button type="button" class="btn btn-plain hover-neon" :class="isVisibleImageCarousel ? 'red' : 'main'" @click="isVisibleImageCarousel = !isVisibleImageCarousel">
            {{ isVisibleImageCarousel ? 'Ocultar Image Carousel' : 'Mostrar Image Carousel' }}
          </button>
        </div>
        <div class="col-md-12">
          <button type="button" class="btn btn-plain hover-neon" :class="isVisibleCarouselBootstrap ? 'red' : 'tertiary'" @click="isVisibleCarouselBootstrap = !isVisibleCarouselBootstrap">
            {{ isVisibleCarouselBootstrap ? 'Ocultar Carousel Bootstrap' : 'Mostrar Carousel Bootstrap' }}
          </button>
        </div>
      </div>
      <!-- #################### BOTONES #################### -->
      <div class="bg-light border m-4 p-4" v-if="isVisibleBotones">
        <div class="row">
          <div class="col-md-12 text-subtitle">Dropdown Buttons</div>
          <div class="col-md-12 d-flex flex-wrap gap-2 my-3 justify-content-center">
            <!-- Dropdown default -->
            <div class="dropdown dropdown-custom">
              <button class="btn btn-dropdown dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">Default</button>
              <ul class="dropdown-menu">
                <li class="dropdown-item">
                  <a class="btn">Testing Element 1</a>
                </li>
                <li class="dropdown-item">
                  <a class="btn">Testing Element 2</a>
                </li>
              </ul>
            </div>
            <!-- Dropdown Default + Separador -->
            <div class="dropdown dropdown-custom">
              <button class="btn btn-dropdown dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">Default + Separador</button>
              <ul class="dropdown-menu">
                <slot>
                  <div class="dropdown-subtitle">Testing 01</div>
                  <li class="dropdown-item">
                    <a checked>Testing 1</a>
                  </li>
                  <li class="dropdown-item">
                    <a>Testing 2</a>
                  </li>
                </slot>
                <hr class="mx-1 my-3 separador-horizontal separador-horizontal-black" />
                <slot>
                  <div class="dropdown-subtitle">Testing 02</div>
                  <slot>
                    <li class="dropdown-item">
                      <a>Testing 3</a>
                    </li>
                  </slot>
                </slot>
              </ul>
            </div>
            <!-- Dropdown main -->
            <div class="dropdown dropdown-custom dropdown-custom-main">
              <button class="btn btn-dropdown dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">Main</button>
              <ul class="dropdown-menu">
                <li class="dropdown-item">
                  <a class="btn">Testing Element 1</a>
                </li>
                <li class="dropdown-item">
                  <a class="btn">Testing Element 2</a>
                </li>
              </ul>
            </div>
            <!-- Dropdown squared -->
            <div class="dropdown dropdown-custom dropdown-custom-squared">
              <button class="btn btn-dropdown dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">Squared</button>
              <ul class="dropdown-menu">
                <li class="dropdown-item">
                  <a class="btn">Testing Element 1</a>
                </li>
                <li class="dropdown-item">
                  <a class="btn">Testing Element 2</a>
                </li>
              </ul>
            </div>
            <!-- Dropdown yellow -->
            <div class="dropdown dropdown-custom dropdown-custom-yellow">
              <button class="btn btn-dropdown dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">Yellow</button>
              <ul class="dropdown-menu">
                <li class="dropdown-item">
                  <a class="btn">Testing Element 1</a>
                </li>
                <li class="dropdown-item">
                  <a class="btn">Testing Element 2</a>
                </li>
              </ul>
            </div>
            <!-- Dropdown red -->
            <div class="dropdown dropdown-custom dropdown-custom-red">
              <button class="btn btn-dropdown dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">Red</button>
              <ul class="dropdown-menu">
                <li class="dropdown-item">
                  <a class="btn">Testing Element 1</a>
                </li>
                <li class="dropdown-item">
                  <a class="btn">Testing Element 2</a>
                </li>
              </ul>
            </div>
            <!-- Dropdown green -->
            <div class="dropdown dropdown-custom dropdown-custom-green">
              <button class="btn btn-dropdown dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">Green</button>
              <ul class="dropdown-menu">
                <li class="dropdown-item">
                  <a class="btn">Testing Element 1</a>
                </li>
                <li class="dropdown-item">
                  <a class="btn">Testing Element 2</a>
                </li>
              </ul>
            </div>
          </div>
          <hr class="separador-horizontal" />
          <div class="col-md-12 text-subtitle">Plain Buttons (hover-simple)</div>
          <div class="col-md-12 d-flex flex-wrap gap-2 my-3 justify-content-center">
            <button type="button" class="btn btn-sm btn-plain hover-simple main">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-plain hover-simple secondary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-plain hover-simple tertiary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-plain hover-simple quaternary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-plain hover-simple red">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-plain hover-simple green">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-plain hover-simple yellow">Texto de Prueba</button>
          </div>
          <hr class="separador-horizontal" />
          <div class="col-md-12 text-subtitle">Plain Buttons (hover-neon)</div>
          <div class="col-md-12 d-flex flex-wrap gap-2 my-3 justify-content-center">
            <button type="button" class="btn btn-sm btn-plain hover-neon main">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-plain hover-neon secondary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-plain hover-neon tertiary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-plain hover-neon quaternary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-plain hover-neon red">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-plain hover-neon green">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-plain hover-neon yellow">Texto de Prueba</button>
          </div>
          <hr class="separador-horizontal" />
          <div class="col-md-12 text-subtitle">Plain Buttons (hover-neon border-white)</div>
          <div class="col-md-12 d-flex flex-wrap gap-2 my-3 justify-content-center">
            <button type="button" class="btn btn-sm btn-plain hover-neon border-white main">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-plain hover-neon border-white secondary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-plain hover-neon border-white tertiary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-plain hover-neon border-white quaternary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-plain hover-neon border-white red">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-plain hover-neon border-white green">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-plain hover-neon border-white yellow">Texto de Prueba</button>
          </div>
          <hr class="separador-horizontal" />
          <div class="col-md-12 text-subtitle">Square Buttons (hover-simple)</div>
          <div class="col-md-12 d-flex flex-wrap gap-2 my-3 justify-content-center">
            <button type="button" class="btn btn-sm btn-squared hover-simple main">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-squared hover-simple secondary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-squared hover-simple tertiary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-squared hover-simple quaternary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-squared hover-simple red">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-squared hover-simple green">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-squared hover-simple yellow">Texto de Prueba</button>
          </div>
          <hr class="separador-horizontal" />
          <div class="col-md-12 text-subtitle">Square Buttons (hover-background)</div>
          <div class="col-md-12 d-flex flex-wrap gap-2 my-3 justify-content-center">
            <button type="button" class="btn btn-sm btn-squared hover-background main">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-squared hover-background secondary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-squared hover-background tertiary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-squared hover-background quaternary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-squared hover-background red">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-squared hover-background green">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-squared hover-background yellow">Texto de Prueba</button>
          </div>
          <hr class="separador-horizontal" />
          <div class="col-md-12 text-subtitle">Neon Buttons (hover-simple)</div>
          <div class="col-md-12 d-flex flex-wrap gap-2 my-3 justify-content-center">
            <button type="button" class="btn btn-sm btn-neon hover-simple main">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-neon hover-simple secondary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-neon hover-simple tertiary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-neon hover-simple quaternary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-neon hover-simple red">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-neon hover-simple green">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-neon hover-simple yellow">Texto de Prueba</button>
          </div>
          <hr class="separador-horizontal" />
          <div class="col-md-12 text-subtitle">Neon Buttons (hover-neon)</div>
          <div class="col-md-12 d-flex flex-wrap gap-2 my-3 justify-content-center">
            <button type="button" class="btn btn-sm btn-neon hover-neon main">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-neon hover-neon secondary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-neon hover-neon tertiary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-neon hover-neon quaternary">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-neon hover-neon red">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-neon hover-neon green">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-neon hover-neon yellow">Texto de Prueba</button>
          </div>
          <hr class="separador-horizontal" />
          <div class="col-md-12 text-subtitle">Other Buttons</div>
          <div class="col-md-12 d-flex flex-wrap gap-2 my-3 justify-content-center">
            <button type="button" class="btn btn-sm btn-ocultar">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-cuadrado">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-agregar">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-selection">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-selected">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-price">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-second-option">Texto de Prueba</button>
            <button type="button" class="btn btn-sm btn-cerrar-modal">Texto de Prueba</button>
          </div>
          <button class="btn btn-cerrar-modal"><i class="fa-solid fa-circle-xmark"></i></button>
          <hr class="separador-horizontal" />
          <div class="col-md-12 text-subtitle">Badges</div>
          <span>Texto de Prueba<span class="mx-2 badge badge-main badge-lg">Badge LG</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-main badge-md">Badge MD</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-main badge-sm">Badge SM</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-main">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-secondary">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-red">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-yellow">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-green">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-white">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-gray">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-black">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-main badge-border">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-secondary badge-border">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-red badge-border">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-yellow badge-border">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-green badge-border">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-white badge-border">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-gray badge-border">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-black badge-border">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-main badge-border badge-transparent">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-secondary badge-border badge-transparent">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-red badge-border badge-transparent">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-yellow badge-border badge-transparent">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-green badge-border badge-transparent">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-white badge-border badge-transparent">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-gray badge-border badge-transparent">Badge</span></span>
          <span>Texto de Prueba<span class="mx-2 badge badge-black badge-border badge-transparent">Badge</span></span>
          <hr class="separador-horizontal" />
          <div class="col-md-12 text-subtitle">Social-Icon Buttons</div>
          <div class="col-md-12 d-flex flex-wrap gap-2 my-3 justify-content-center">
            <button type="button" class="social-icon main social-icon-l">
              <i class="fa-solid fa-icons"></i>
            </button>
            <button type="button" class="social-icon main">
              <i class="fa-solid fa-icons"></i>
            </button>
            <button type="button" class="social-icon main social-icon-s">
              <i class="fa-solid fa-icons"></i>
            </button>
            <button type="button" class="social-icon secondary social-icon-s">
              <i class="fa-solid fa-icons"></i>
            </button>
            <button type="button" class="social-icon tertiary social-icon-s">
              <i class="fa-solid fa-icons"></i>
            </button>
            <button type="button" class="social-icon quaternary social-icon-s">
              <i class="fa-solid fa-icons"></i>
            </button>
            <button type="button" class="social-icon red social-icon-s">
              <i class="fa-solid fa-icons"></i>
            </button>
            <button type="button" class="social-icon yellow social-icon-s">
              <i class="fa-solid fa-icons"></i>
            </button>
            <button type="button" class="social-icon green social-icon-s">
              <i class="fa-solid fa-icons"></i>
            </button>
            <button type="button" class="social-icon gray social-icon-s">
              <i class="fa-solid fa-icons"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- #################### TEXTOS #################### -->
      <div class="bg-light border m-4 p-4" v-if="isVisibleTextos">
        <div class="col-md-12 text-subtitle">Titulos:</div>
        <p class="">Texto de Prueba (no-class)</p>
        <p class="text-title">Texto de Prueba (title)</p>
        <p class="text-subtitle">Texto de Prueba (subtitle)</p>
        <p class="text-preamble">Texto de Prueba (preamble)</p>
        <hr class="separador-horizontal" />
        <div class="col-md-12 text-subtitle">Custom Text-Alert:</div>
        <p class="text-alert main">Texto de Prueba (main)</p>
        <p class="text-alert red">Texto de Prueba (red)</p>
        <p class="text-alert yellow">Texto de Prueba (yellow)</p>
        <p class="text-alert green">Texto de Prueba (green)</p>
        <p class="text-alert gray">Texto de Prueba (gray)</p>
        <p class="text-alert main hover-simple">Texto de Prueba (hover-simple main)</p>
        <p class="text-alert red hover-simple">Texto de Prueba (hover-simple red)</p>
        <p class="text-alert yellow hover-simple">Texto de Prueba (hover-simple yellow)</p>
        <p class="text-alert green hover-simple">Texto de Prueba (hover-simple green)</p>
        <p class="text-alert gray hover-simple">Texto de Prueba (hover-simple gray)</p>
        <p class="text-alert main hover-neon">Texto de Prueba (hover-neon main)</p>
        <p class="text-alert red hover-neon">Texto de Prueba (hover-neon red)</p>
        <p class="text-alert yellow hover-neon">Texto de Prueba (hover-neon yellow)</p>
        <p class="text-alert green hover-neon">Texto de Prueba (hover-neon green)</p>
        <p class="text-alert gray hover-neon">Texto de Prueba (hover-neon gray)</p>
        <hr class="separador-horizontal" />
        <div class="col-md-12 text-subtitle">Custom Citation:</div>
        <p class="text-citation text-citation-main">Texto de Prueba (main)</p>
        <p class="text-citation text-citation-red">Texto de Prueba (red)</p>
        <p class="text-citation text-citation-yellow">Texto de Prueba (yellow)</p>
        <p class="text-citation text-citation-green">Texto de Prueba (green)</p>
        <p class="text-citation text-citation-gray">Texto de Prueba (gray)</p>
        <hr class="separador-horizontal" />
        <div class="col-md-12 text-subtitle">Marquee:</div>
        <div class="text-center mx-auto" style="width: 500px">
          <Marquee text="Este texto se mueve infinitamente al pasar el mouse." :infiniteOnHover="true" />
          <Marquee text="Este texto solo se mueve una vez al pasar el mouse." :infiniteOnHover="false" />
        </div>
        <hr class="separador-horizontal" />
        <div class="col-md-12 text-subtitle">Fonts:</div>
        <p class="montserrat-font">Texto de Prueba (Montserrat)</p>
        <p class="roboto-font">Texto de Prueba (Roboto)</p>
        <p class="jersey-10-font">Texto de Prueba (Jersey-10)</p>
        <p class="oswald-font">Texto de Prueba (Oswald)</p>
        <p class="orbitron-font">Texto de Prueba (Orbitron)</p>
        <p class="advent-pro-font">Texto de Prueba (Advent-PRO)</p>
        <p class="shantell-sans-font">Texto de Prueba (Shantell-Sans)</p>
        <hr class="separador-horizontal" />
        <div class="col-md-12 text-subtitle">Text-Colors:</div>
        <p class="text-color-light">Texto de Prueba (light)</p>
        <p class="text-color-dark">Texto de Prueba (dark)</p>
        <p class="text-color-main">Texto de Prueba (main)</p>
        <p class="text-color-red">Texto de Prueba (red)</p>
        <p class="text-color-yellow">Texto de Prueba (yellow)</p>
        <p class="text-color-green">Texto de Prueba (green)</p>
        <p class="text-color-gray">Texto de Prueba (gray)</p>
        <p class="text-color-highlight">Texto de Prueba (highlight)</p>
        <hr class="separador-horizontal" />
        <div class="col-md-12 text-subtitle">Links Custom:</div>
        <p><a class="link-custom main">Texto de Prueba (main)</a></p>
        <p><a class="link-custom secondary">Texto de Prueba (secondary)</a></p>
        <p><a class="link-custom tertiary">Texto de Prueba (tertiary)</a></p>
        <p><a class="link-custom quaternary">Texto de Prueba (quaternary)</a></p>
        <p><a class="link-custom red">Texto de Prueba (red)</a></p>
        <p><a class="link-custom yellow">Texto de Prueba (yellow)</a></p>
        <p><a class="link-custom green">Texto de Prueba (green)</a></p>
        <p><a class="link-custom gray">Texto de Prueba (gray)</a></p>
        <p><a class="link-custom main anim-none">Sin Animación</a></p>
        <p><a class="link-custom main anim-center">Animación Centro → Lados</a></p>
        <p><a class="link-custom main anim-left">Animación Izquierda → Derecha</a></p>
        <p><a class="link-custom main anim-down">Animación Arriba → Abajo</a></p>
        <hr class="separador-horizontal" />
        <div class="col-md-12 text-subtitle">Otros:</div>
        <p class="foot-note-custom">Texto de Prueba (foot-note)</p>
        <p class="text-neon">Texto de Prueba (neon)</p>
        <p class="text-small">Texto de Prueba (small)</p>
      </div>
      <!-- #################### MODALES #################### -->
      <div class="bg-light border m-4 p-4" v-if="isVisibleModales">
        <!-- Popup -->
        <button class="btn btn-sm btn-plain hover-neon main" type="button" @click="testPopup()">Popup</button>
        <!-- Confirmation -->
        <button class="btn btn-sm btn-plain hover-neon main" type="button" @click="testConfir()">Confirmación</button>
        <!-- Toastification -->
        <button class="btn btn-sm btn-plain hover-neon main" type="button" @click="testToast()">Toastification</button>
        <!-- Reusable Modal -->
        <button class="btn btn-sm btn-plain hover-neon main" type="button" @click="showReusableModal = !showReusableModal">Reusable Modal</button>
        <reusable-modal v-if="showReusableModal" @close="showReusableModal = false" ref="testingModal" customClass="modal-container modal-container-s" />
        <!-- Reusable Window -->
        <button class="btn btn-sm btn-plain hover-neon main" type="button" @click="$refs.testingWindow.open()">Reusable Window</button>
        <reusable-window ref="testingWindow">
          <p>Contenido</p>
          <button class="btn btn-sm btn-plain red" type="button" @click="$refs.testingWindow.close()">Reusable Window Close</button>
        </reusable-window>
      </div>
      <!-- #################### CAROUSEL #################### -->
      <div class="bg-light border m-4 p-4" v-if="isVisibleCarousel">
        <Carousel :totalSlides="4" :texts="texts" :textsMobile="textsMobile" :titles="titles" :imagesURL="imagesURL" />
      </div>
      <!-- #################### Image Carousel #################### -->
      <div class="bg-light border m-4 p-4" v-if="isVisibleImageCarousel">
        <ImageCarousel :imagesURL="imagesURL2" />
      </div>
      <!-- #################### CAROUSEL BOOTSTRAP #################### -->
      <div class="bg-light border m-4 p-4" v-if="isVisibleCarouselBootstrap">
        <div id="carouselData" class="carousel slide" data-bs-interval="false" data-bs-keyboard="false">
          <div class="carousel-indicators">
            <button type="button" data-bs-target="#carouselData" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
            <button type="button" data-bs-target="#carouselData" data-bs-slide-to="1" aria-label="Slide 2"></button>
            <button type="button" data-bs-target="#carouselData" data-bs-slide-to="2" aria-label="Slide 3"></button>
          </div>
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img src="/images/FondoNeon.jpg" class="d-block w-100" alt="Imagen de prueba carrusel 1." />
            </div>
            <div class="carousel-item">
              <img src="/images/FondoNeon.jpg" class="d-block w-100" alt="Imagen de prueba carrusel 2." />
            </div>
            <div class="carousel-item">
              <img src="/images/FondoNeon.jpg" class="d-block w-100" alt="Imagen de prueba carrusel 3." />
            </div>
          </div>
          <button class="carousel-control-prev" type="button" data-bs-target="#carouselData" data-bs-slide="prev">
            <i class="fa-solid fa-angles-left fa-2xl"></i>
            <span class="visually-hidden">Anterior</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#carouselData" data-bs-slide="next">
            <i class="fa-solid fa-angles-right fa-2xl"></i>
            <span class="visually-hidden">Siguiente</span>
          </button>
        </div>
      </div>
    </div>
    <!-- ############################################################################################### -->
    <modalPopupWindow ref="popup"></modalPopupWindow>
    <modalConfirmation ref="confirmation"></modalConfirmation>
  </main>
</template>

<script>
import { GlobalMixin } from '@mixins/GlobalMixin';
import Marquee from '@snippets/base/Marquee.vue';
import modalConfirmation from '@snippets/base/Confirmation.vue';
import modalPopupWindow from '@snippets/base/PopupWindow.vue';
import ReusableModal from '@snippets/base/ReusableModal.vue';
import ReusableWindow from '@snippets/base/ReusableWindow.vue';
import ImageCarousel from '@snippets/base/ImageCarousel.vue';
import Carousel from '@snippets/base/Carousel.vue';
import { footerHeight } from '@states/FooterState';

export default {
  name: 'Testing',
  mixins: [GlobalMixin],
  components: { Marquee, modalConfirmation, modalPopupWindow, ReusableModal, ReusableWindow, ImageCarousel, Carousel },
  setup() {
    return { footerHeight };
  },
  computed: {
    paymentState() {
      return PaymentService.state;
    },
  },
  data() {
    return {
      isVisibleModales: false,
      isVisibleBotones: false,
      isVisibleTextos: false,
      isVisibleCarousel: false,
      isVisibleImageCarousel: false,
      isVisibleCarouselBootstrap: false,
      // #########################################
      showReusableWindow: false,
      showReusableModal: false,
      idPlan: 1,
      testEmail: null,
      idUsuario: null, // Si es null, se creará un nuevo usuario
      nombres: 'John',
      apellidos: 'Doe',
      rut: '28015860-7',
      password: 'securepassword',
      ingresoCompleto: true,
      idRol: 2,
      frecuencia: 'monthly',
      texts: [
        `AI Alpha Analytics specializes in developing
								<span class="text-color-dark">AI-driven solutions</span>
								to help organizations excel in a digital world by solving complex challenges, enhancing efficiency, and driving growth.`,
        `We offer a range of <span class="text-color-dark">advanced tools</span>, including predictive analytics, automation,
								and data insights, designed to meet diverse business needs with <span class="text-color-dark">reliable and scalable software.</span>`,
        `Committed to building strong, trust-based partnerships, AI Alpha Analytics focuses on
								<span class="text-color-dark">delivering impactful solutions</span>
								that meet current demands and anticipate future opportunities in technology.`,
        `Our mission is to push technology's boundaries by delivering intelligent, adaptable, and tailored solutions.
								Focused on addressing current challenges, they also equip organizations to lead in an ever-evolving digital landscape. <br><br>
								<span class="text-color-dark">With AI Alpha Analytics, you're not just keeping up with the future, you're leading it.</span>`,
      ],
      textsMobile: [
        `AI Alpha Analytics specializes in developing
								<span class="text-color-dark">AI-driven solutions</span>
								to help organizations excel in a digital world by solving complex challenges, enhancing efficiency, and driving growth.`,
        `We offer a range of <span class="text-color-dark">advanced tools</span>, including predictive analytics, automation,
								and data insights, designed to meet diverse business needs with <span class="text-color-dark">reliable and scalable software.</span>`,
        `Committed to building strong, trust-based partnerships, AI Alpha Analytics focuses on
								<span class="text-color-dark">delivering impactful solutions</span>
								that meet current demands and anticipate future opportunities in technology.`,
        `Our mission is to push technology's boundaries by delivering intelligent, adaptable, and tailored solutions.
								Focused on addressing current challenges, they also equip organizations to lead in an ever-evolving digital landscape. <br><br>
								<span class="text-color-dark">With AI Alpha Analytics, you're not just keeping up with the future, you're leading it.</span>`,
      ],
      titles: ['Comprehensive Offerings', 'Innovative Tech & Tools', 'Partnership & Vision', 'Our Commitment'],
      imagesURL: ['/images/FondoNeon.jpg', '/images/FondoNeon.jpg', '/images/FondoNeon.jpg', '/images/FondoNeon.jpg'],
      imagesURL2: ['/images/FaceLab/LogotipoFaceLab(FO).webp', '/images/AIA/LogotipoAIA(FO).webp', '/images/FaceLab/LogotipoFaceLab(FO).webp', '/images/AIA/LogotipoAIA(FO).webp', '/images/FaceLab/LogotipoFaceLab(FO).webp', '/images/AIA/LogotipoAIA(FO).webp', '/images/FaceLab/LogotipoFaceLab(FO).webp'],
      data: [
        { year: 2010, count: 10 },
        { year: 2011, count: 20 },
        { year: 2024, count: 15 },
        { year: 2025, count: 25 },
        { year: 2014, count: 22 },
        { year: 2015, count: 30 },
        { year: 2016, count: 28 },
      ],
    };
  },
  methods: {
    onCountdownFinishedTimer() {
      console.log('!Finalizó el tiempo!');
      console.log('Se sumarán 10 segundos.');
      this.showTimer = false;
      this.targetDateTimer = this.dayjs().add(10, 'seconds');
    },
    generateBuyOrder() {
      return `ORDER-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
    },
    onPagoExitoso(data) {
      console.log('Pago Confirmado:', data);
      this.toast('success', `Pago Confirmado: ${data}`);
    },
    onPagoFallido(error) {
      console.error('Pago Fallido:', error);
      this.toast('error', `Pago Fallido: ${error}`);
    },
    triggerLoading() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 3000);
    },
    async testLogoutAlert() {
      const ok = await this.$refs.logoutAlert.show({
        expirationSeconds: 600,
      });
      if (ok) {
        console.log('Continua la sesión');
      } else {
        console.log('Cierra sesión');
      }
    },
    async testPopup() {
      const ok = await this.$refs.popup.show({
        title: `Título`,
        message: `Mensaje`,
        okButton: 'Continuar',
      });
      if (ok) {
        this.$emit('close');
      }
    },
    async testConfir() {
      const ok = await this.$refs.confirmation.show({
        title: `Título`,
        message: `Mensaje`,
        cancelButton: 'Volver',
        okButton: 'Continuar',
      });
      if (ok) {
        console.log('Aceptado!');
      }
    },
    async testToast() {
      this.toast('info', `Toastification Toast!`);
    },
    getCandlestickData() {
      return [
        { x: new Date('2025-01-27'), y: [40.1, 43.4, 38.6, 42.2] },
        { x: new Date('2025-01-29'), y: [40.2, 43.5, 38.8, 42.7] },
        { x: new Date('2025-01-31'), y: [40.4, 43.6, 38.7, 42.8] },
        { x: new Date('2025-02-01'), y: [41.1, 44.2, 39.6, 43.8] },
        { x: new Date('2025-02-03'), y: [40.2, 43.4, 38.7, 42.9] },
        { x: new Date('2025-02-05'), y: [38.2, 41.6, 36.9, 40.1] },
        { x: new Date('2025-02-07'), y: [40.1, 43.8, 38.3, 42.9] },
        { x: new Date('2025-02-09'), y: [40.1, 43.5, 38.9, 42.7] },
        { x: new Date('2025-02-11'), y: [40.5, 43.7, 38.9, 42.9] },
        { x: new Date('2025-02-13'), y: [41.2, 44.5, 36.9, 41.6] },
        { x: new Date('2025-02-15'), y: [40.1, 43.4, 38.3, 42.2] },
        { x: new Date('2025-02-17'), y: [40.2, 43.5, 38.8, 42.7] },
        { x: new Date('2025-02-19'), y: [40.5, 43.5, 38.5, 42.5] },
        { x: new Date('2025-02-21'), y: [41.3, 44.2, 39.6, 43.8] },
        { x: new Date('2025-02-23'), y: [40.9, 43.6, 38.7, 42.4] },
        { x: new Date('2025-02-25'), y: [38.8, 41.7, 36.9, 40.4] },
        { x: new Date('2025-02-27'), y: [40.5, 43.8, 38.6, 42.6] },
        { x: new Date('2025-03-01'), y: [40.2, 43.9, 38.1, 42.7] },
        { x: new Date('2025-03-03'), y: [40.5, 43.1, 38.5, 42.2] },
        { x: new Date('2025-03-05'), y: [41.2, 44.5, 36.9, 41.4] },
      ];
    },
    getUpperBandData() {
      return [
        { x: new Date('2025-01-27'), y: 40.1 },
        { x: new Date('2025-01-29'), y: 40.2 },
        { x: new Date('2025-01-31'), y: 39.3 },
        { x: new Date('2025-02-01'), y: 38.5 },
        { x: new Date('2025-02-03'), y: 39.6 },
        { x: new Date('2025-02-05'), y: 40.5 },
        { x: new Date('2025-02-07'), y: 40.4 },
        { x: new Date('2025-02-09'), y: 40.9 },
        { x: new Date('2025-02-11'), y: 40.1 },
        { x: new Date('2025-02-13'), y: 41.8 },
        { x: new Date('2025-02-15'), y: 42.2 },
        { x: new Date('2025-02-17'), y: 42.3 },
        { x: new Date('2025-02-19'), y: 42.5 },
        { x: new Date('2025-02-21'), y: 42.6 },
        { x: new Date('2025-02-23'), y: 42.5 },
        { x: new Date('2025-02-25'), y: 42.4 },
        { x: new Date('2025-02-27'), y: 42.9 },
        { x: new Date('2025-03-01'), y: 43.7 },
        { x: new Date('2025-03-03'), y: 43.3 },
        { x: new Date('2025-03-05'), y: 43.2 },
      ];
    },
    getLowerBandData() {
      return [
        { x: new Date('2025-01-27'), y: 36.1 },
        { x: new Date('2025-01-29'), y: 36.2 },
        { x: new Date('2025-01-31'), y: 35.3 },
        { x: new Date('2025-02-01'), y: 34.5 },
        { x: new Date('2025-02-03'), y: 35.6 },
        { x: new Date('2025-02-05'), y: 36.5 },
        { x: new Date('2025-02-07'), y: 36.4 },
        { x: new Date('2025-02-09'), y: 36.9 },
        { x: new Date('2025-02-11'), y: 36.1 },
        { x: new Date('2025-02-13'), y: 37.8 },
        { x: new Date('2025-02-15'), y: 38.2 },
        { x: new Date('2025-02-17'), y: 38.3 },
        { x: new Date('2025-02-19'), y: 38.5 },
        { x: new Date('2025-02-21'), y: 38.6 },
        { x: new Date('2025-02-23'), y: 38.5 },
        { x: new Date('2025-02-25'), y: 38.4 },
        { x: new Date('2025-02-27'), y: 38.9 },
        { x: new Date('2025-03-01'), y: 39.7 },
        { x: new Date('2025-03-03'), y: 39.3 },
        { x: new Date('2025-03-05'), y: 39.2 },
      ];
    },
    getMovingAverageData() {
      return [
        { x: new Date('2025-01-27'), y: 38.1 },
        { x: new Date('2025-01-29'), y: 38.2 },
        { x: new Date('2025-01-31'), y: 38.8 },
        { x: new Date('2025-02-01'), y: 39.5 },
        { x: new Date('2025-02-03'), y: 38.6 },
        { x: new Date('2025-02-05'), y: 38.5 },
        { x: new Date('2025-02-07'), y: 38.4 },
        { x: new Date('2025-02-09'), y: 38.9 },
        { x: new Date('2025-02-11'), y: 38.1 },
        { x: new Date('2025-02-13'), y: 39.8 },
        { x: new Date('2025-02-15'), y: 40.2 },
        { x: new Date('2025-02-17'), y: 40.3 },
        { x: new Date('2025-02-19'), y: 40.5 },
        { x: new Date('2025-02-21'), y: 40.6 },
        { x: new Date('2025-02-23'), y: 40.5 },
        { x: new Date('2025-02-25'), y: 40.4 },
        { x: new Date('2025-02-27'), y: 40.9 },
        { x: new Date('2025-03-01'), y: 41.7 },
        { x: new Date('2025-03-03'), y: 41.3 },
        { x: new Date('2025-03-05'), y: 41.2 },
      ];
    },
    getBandAreaData(upperBandData, lowerBandData) {
      const areaData = [];
      for (let i = 0; i < upperBandData.length; i++) {
        areaData.push({ x: upperBandData[i].x, y: upperBandData[i].y });
      }
      for (let i = lowerBandData.length - 1; i >= 0; i--) {
        areaData.push({ x: lowerBandData[i].x, y: lowerBandData[i].y });
      }
      return areaData;
    },
    getTimeData() {
      return [
        { x: new Date('2025-01-27'), y: 37.94 },
        { x: new Date('2025-01-29'), y: 37.83 },
        { x: new Date('2025-01-31'), y: 38.34 },
        { x: new Date('2025-02-01'), y: 38.1 },
        { x: new Date('2025-02-03'), y: 38.51 },
        { x: new Date('2025-02-05'), y: 38.4 },
        { x: new Date('2025-02-07'), y: 38.07 },
        { x: new Date('2025-02-09'), y: 39.12 },
        { x: new Date('2025-02-11'), y: 38.64 },
        { x: new Date('2025-02-13'), y: 38.89 },
        { x: new Date('2025-02-15'), y: 38.81 },
        { x: new Date('2025-02-17'), y: 38.61 },
        { x: new Date('2025-02-19'), y: 38.63 },
        { x: new Date('2025-02-21'), y: 38.99 },
        { x: new Date('2025-02-23'), y: 38.77 },
        { x: new Date('2025-02-25'), y: 38.34 },
        { x: new Date('2025-02-27'), y: 38.55 },
        { x: new Date('2025-03-01'), y: 38.11 },
        { x: new Date('2025-03-03'), y: 38.59 },
        { x: new Date('2025-03-05'), y: 39.6 },
      ];
    },
    updateData(timeline) {
      this.selection = timeline;
      switch (timeline) {
        case 'one_month':
          this.$refs.chart.zoomX(new Date('2025-01-28').getTime(), new Date('2025-02-27').getTime());
          break;
        case 'six_months':
          this.$refs.chart.zoomX(new Date('2024-09-27').getTime(), new Date('2025-02-27').getTime());
          break;
        case 'one_year':
          this.$refs.chart.zoomX(new Date('2024-02-27').getTime(), new Date('2025-02-27').getTime());
          break;
        case 'ytd':
          this.$refs.chart.zoomX(new Date('2025-01-01').getTime(), new Date('2025-02-27').getTime());
          break;
        case 'all':
          this.$refs.chart.zoomX(new Date('2024-01-23').getTime(), new Date('2025-02-27').getTime());
          break;
        default:
      }
    },
    updateData2(timeline) {
      this.selection2 = timeline;
      switch (timeline) {
        case 'one_month':
          this.$refs.chart2.zoomX(new Date('2025-01-28').getTime(), new Date('2025-02-27').getTime());
          break;
        case 'six_months':
          this.$refs.chart2.zoomX(new Date('2024-09-27').getTime(), new Date('2025-02-27').getTime());
          break;
        case 'one_year':
          this.$refs.chart2.zoomX(new Date('2024-02-27').getTime(), new Date('2025-02-27').getTime());
          break;
        case 'ytd':
          this.$refs.chart2.zoomX(new Date('2025-01-01').getTime(), new Date('2025-02-27').getTime());
          break;
        case 'all':
          this.$refs.chart2.zoomX(new Date('2024-01-23').getTime(), new Date('2025-02-27').getTime());
          break;
        default:
      }
    },
    testingUTC() {
      const actual = this.dayjs();
      const databaseReturn = '2025-05-09 15:47:56'; // HORA EN UTC +00:00
      const databaseReturnEnLocal = this.toLocalDateTime(databaseReturn); // SIEMPRE QUE SE RECIBA SE DEBE REALIZAR
      console.log('databaseReturnEnLocal (LOCAL): ', databaseReturnEnLocal); // EN HORA LOCAL
      console.log('actual (LOCAL): ', actual); // EN HORA LOCAL
      console.log('databaseReturnEnLocal (UTC): ', this.dayjs(databaseReturn).utc()); // EN HORA UTC
      console.log('actual (UTC): ', this.dayjs().utc(actual)); // EN HORA UTC
    },
    sendTestEmail(tipoCorreo) {
      const data = {
        tipo_correo: tipoCorreo,
        email: this.testEmail,
      };
      getAxiosInstance()
        .post('/smtp/mail_testing', data)
        .then(() => this.toast('success', `Correo '${tipoCorreo}' enviado a ${this.testEmail}.`))
        .catch(() => this.toast('error', `Error al enviar ${tipoCorreo}`));
    },
    getFlujoPacientes() {
      this.getPacientes()
        .then((response) => {
          this.pacientes = response;
        })
        .catch((e) => console.log(e));
    },
    getFlujoArchivos(idUsuario) {
      this.showFileDownloading = false;
      this.getArchivos(idUsuario)
        .then((response) => {
          this.archivos = response;
          this.showFileDownloading = true;
        })
        .catch((e) => console.log(e));
    },
    handleTestClick({ entrada }) {
      this.toast('info', `Funciona! INPUT: ${entrada}`);
    },
    generateQR() {
      try {
        getAxiosInstance()
          .get('/links/qr', {
            params: { data: 'Texto de prueba' },
          })
          .then((response) => {
            this.advancedLinks.qr_b64 = response.data.qr_base64;
            this.toast('success', 'QR generado correctamente.');
          });
      } catch {
        this.toast('error', 'Error al generar QR');
      }
    },
    generateShortLink() {
      try {
        getAxiosInstance()
          .get('/links/short')
          .then((response) => {
            this.advancedLinks.shortLink = response.data.url;
            this.toast('success', 'Short Link generado correctamente.');
          });
      } catch {
        this.toast('error', 'Error al generar Short Link');
      }
    },
    generateSignedUrl() {
      try {
        getAxiosInstance()
          .get('/links/signed', {
            params: { path: '/login', expires_in: 300 },
          })
          .then((response) => {
            this.advancedLinks.signedUrl = response.data.signed_url;
            this.toast('success', 'Signed URL generado correctamente.');
          });
      } catch {
        this.toast('error', 'Error al generar Signed URL');
      }
    },
    validateSignedUrl(createFalse = false) {
      if (!this.advancedLinks.signedUrl) {
        this.toast('error', 'Genera la Signed URL primero.');
        return;
      }

      try {
        getAxiosInstance()
          .get('/links/signed/validate', {
            params: { full_url: createFalse ? this.advancedLinks.signedUrl + 'd832' : this.advancedLinks.signedUrl },
          })
          .then((response) => {
            this.toast(response.data.valid ? 'success' : 'error', `${response.data.valid ? 'Validación exitosa!' : 'Validación erronea.'}`);
          });
      } catch {
        this.toast('error', 'Error al validar Signed URL');
      }
    },
    generateMagicLink() {
      try {
        getAxiosInstance()
          .get('/links/magiclink', {
            params: { user_id: 1 },
          })
          .then((response) => {
            this.advancedLinks.magicLink = response.data.magic_link;
            this.toast('success', 'Magic Link generado correctamente.');
          });
      } catch {
        this.toast('error', 'Error al generar Magic Link');
      }
    },
    validateMagicLink(createFalse = false) {
      if (!this.advancedLinks.magicLink) {
        this.toast('error', 'Genera el Magic Link primero.');
        return;
      }
      const magicToken = new URL(this.advancedLinks.magicLink).searchParams.get('token');

      try {
        getAxiosInstance()
          .post('/login/magiclink/validate', { magicToken: createFalse ? magicToken + 'd832' : magicToken })
          .then((response) => {
            this.toast(response.data.success == true ? 'success' : 'error', `${response.data.success == true ? 'Validación exitosa!' : 'Validación erronea.'}`);
          });
      } catch {
        this.toast('error', 'Error al validar Magic Link');
      }
    },
    generatePIN() {
      try {
        getAxiosInstance()
          .get('/links/pin', {
            params: { digits: 6 },
          })
          .then((response) => {
            this.advancedLinks.pin = response.data.pin;
            this.toast('success', 'PIN generado correctamente.');
          });
      } catch {
        this.toast('error', 'Error al generar PIN');
      }
    },
    generateDeepLink() {
      try {
        getAxiosInstance()
          .get('/links/deeplink', {
            params: {
              user: '12',
              endpoint: 'login',
              app_scheme: 'flmobile',
            },
          })
          .then((response) => {
            this.advancedLinks.deepLink = response.data.deep_link;
            this.toast('success', 'Deep Link generado correctamente.');
          });
      } catch {
        this.toast('error', 'Error al generar Deep Link');
      }
    },
  },
};
</script>
